"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Partner = void 0;
const PartnerTypes_1 = require("../types/PartnerTypes");
const userAttrs_1 = require("../util/userAttrs");
const DefaultContactDetails_1 = require("./commonAttributeSets/DefaultContactDetails");
const ModelCommon_1 = require("./ModelCommon");
const typeName = 'Partner';
class Partner extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        super(ob?.type ?? typeName, { ...(ob ?? {}) });
        this.name = ob?.name ?? '';
        this.partnerType = ob?.partnerType ?? '';
        this.email = ob?.email ?? '';
        this.dwelling_number = ob?.dwelling_number ?? '';
        this.street_name = ob?.street_name ?? '';
        this.suburb = ob?.suburb ?? '';
        this.city = ob?.city ?? '';
        this.country = ob?.country ?? '';
        this.post_code = ob?.post_code ?? '';
        this.phoneNumber = ob?.phoneNumber ?? '';
        this.url = ob?.url ?? '';
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            ...(0, userAttrs_1.hideAttrsFromList)(DefaultContactDetails_1.OptionalContactDetails),
            name: {
                type: 'String',
                required: true,
                editable: true,
            },
            partnerType: {
                type: 'Enum',
                editable: true,
                label: 'Partner Type',
                enumKv: PartnerTypes_1.PartnerTypeEnum,
                required: true,
            },
            url: {
                type: 'String',
                editable: true,
                description: 'A link to the partners website',
                label: 'Website URL',
                required: false,
            },
        };
    }
}
exports.Partner = Partner;
